import React from "react"
import type { IconProps } from './../../models/icon';

export function ArrowDownIcon({
  width = 24,
  height = 24,
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M12 0.857147V23.1429"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M18 17.1429L12 23.1429L6 17.1429"
      />
    </svg>
  );
}
